import React from 'react';

interface FilterChipProps {
  label: string;
  count: number;
  active: boolean;
  onClick: () => void;
}

/** Pill-shaped "Label (count)" filter toggle used by the case Notes and Tasks sidebars. */
export const FilterChip: React.FC<FilterChipProps> = ({ label, count, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs transition-colors ${
      active ? 'bg-foreground text-background' : 'bg-muted text-muted-foreground hover:bg-muted/80'
    }`}
  >
    {label} ({count})
  </button>
);
